import { useEffect } from "react";
import "./impressumStyle.css";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";

export default function Impressum() {
    useEffect(() => {
        document.title = "DJ - EMAN"
    }, []);

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div className="impressumContainer">
                <h1>Impressum</h1>
                <div className="verantwortlichkeitsContainer">
                    <h2><b>Verantwortlich:</b></h2>
                    <h2>Elmar Fichtner</h2>
                    <h2>Breslaustraße 31</h2>
                    <h2>95028 Hof</h2>
                    <h2>Freiberuflicher DJ / Künstler</h2>
                    <h2>Als Kleinunternehmer im Sinne von § 19 Abs. 1 UStG Umsatzsteuer befreit</h2>
                    <h2><a href="mailto:event@djeman.de">event@djeman.de</a></h2>
                    <h2>Tel.: <a href="tel:+491713403685"></a>+49 171 3403685</h2>
                    <h2>Copyright © Alle Rechte vorbehalten</h2>
                </div>
            </div>
        </>
    )
}
